import { features, featuresSales, featuresRecruiting, featuresCustomerSuccess, featuresMarketing, featuresServices } from "./featuresData.js";
import { eventTypes, eventTypesSales, eventTypesMarketing, eventTypesRecruiting, eventTypesCustomerSuccess, eventTypesServices } from "./eventTypes.js";
import { eventWays, eventWaysSales, eventWaysMarketing, eventWaysRecruiting, eventWaysCustomerSuccess, eventWaysServices } from "./eventsWays.js";

const menu = document.querySelector(".menu");
const links = document.querySelector(".links");
const year = document.getElementById("year");
const cardsContainer = document.querySelector(".swiper-wrapper:not(.swiper-wrapper1):not(.swiper-wrapper2):not(.swiper-wrapper-sales):not(.swiper-wrapper-recruiting):not(.swiper-wrapper-customer-success):not(.swiper-wrapper-marketing):not(.swiper-wrapper-services):not(.swiper-wrapper-sales-features):not(.swiper-wrapper-recruiting-features):not(.swiper-wrapper-customer-success-features):not(.swiper-wrapper-marketing-features):not(.swiper-wrapper-services-features)");
const cardsContainerSalesFeatures = document.querySelector(".swiper-wrapper-sales-features");
const cardsContainerRecruitingFeatures = document.querySelector(".swiper-wrapper-recruiting-features");
const cardsContainerCustomerSuccessFeatures = document.querySelector(".swiper-wrapper-customer-success-features");
const cardsContainerMarketingFeatures = document.querySelector(".swiper-wrapper-marketing-features");
const cardsContainerServicesFeatures = document.querySelector(".swiper-wrapper-services-features");
const cardsContainer1 = document.querySelector(".swiper-wrapper1");
const cardsContainer2 = document.querySelector(".swiper-wrapper2");
const cardsContainerSales = document.querySelector(".swiper-wrapper-sales");
const cardsContainerRecruiting = document.querySelector(".swiper-wrapper-recruiting");
const cardsContainerCustomerSuccess = document.querySelector(".swiper-wrapper-customer-success");
const cardsContainerMarketing = document.querySelector(".swiper-wrapper-marketing");
const cardsContainerServices = document.querySelector(".swiper-wrapper-services");
const leftArrow = document.querySelector(".swiper-button-next");
const rightArrow = document.querySelector(".swiper-button-prev");
const leftArrow1 = document.querySelector(".swiper-button-next1");
const rightArrow1 = document.querySelector(".swiper-button-prev1");
const leftArrow2 = document.querySelector(".swiper-button-next2");
const rightArrow2 = document.querySelector(".swiper-button-prev2");
const faqQuestions = document.querySelectorAll(".faq-question");
const btnMonthly = document.getElementById("btn1");
const btnYearly = document.getElementById("btn2");

let translateValue = 0;
let moveby = 20;
let end = 60;

let date;
// function setMoveEnd() {
// 	if (window.innerWidth <= 768) {
// 		moveby = 12;
// 		end = 84;
// 	} else {
// 		let moveby = 20;
// 		let end = 60;
// 	}
// }

// setMoveEnd();

function setYear() {
    if (!date) date = new Date();
    year.innerText = date.getFullYear();
}

function toggleMenu() {
    console.log("hi");
    links.classList.toggle("active");
}

function setCards(container = null, data = null) {
    const targetContainer = container || cardsContainer;
    if (!targetContainer) return;
    
    const featuresData = data || features;
    let html = ``;
    featuresData.forEach((feature) => {
        html += `<div class="card swiper-slide">
						<div class="content">
							<span
								>${feature.icon}
							</span>
							<h5>${feature.title}</h5>
							<p>
							${feature.content}
							</p>
						</div>
					</div>`;
    });

    if (translateValue == 0 && rightArrow) {
        rightArrow.classList.add("disabled");
    }
    targetContainer.innerHTML = html;
}
function setCardsOfEventWays(container = null, data = null) {
    const targetContainer = container || cardsContainer1;
    if (!targetContainer) return;
    
    const eventWaysData = data || eventWays;
    let html = ``;
    eventWaysData.forEach((feature) => {
        html += `<div class="card swiper-slide">
						<div class="content">
							<span
								>${feature.icon}
							</span>
							<h5>${feature.title}</h5>
							<p>
							${feature.content}
							</p>
						</div>
					</div>`;
    });

    if (translateValue == 0 && rightArrow2) {
        rightArrow2.classList.add("disabled");
    }
    targetContainer.innerHTML = html;
}
function setCardsOfEventTypes(container = null, data = null) {
    const targetContainer = container || cardsContainer2;
    if (!targetContainer) return;
    
    const eventData = data || eventTypes;
    let html = ``;
    eventData.forEach((feature) => {
        html += `<div class="card card-event-types swiper-slide">
						<div class="content">
							<span
								>${feature.icon}
							</span>
							<h5>${feature.title}</h5>
							<p>
							${feature.content1}
							</p>
                            ${feature.content2 ? `<p>${feature.content2}</p>` : ''}
						</div>
					</div>`;
    });

    if (translateValue == 0 && rightArrow1) {
        rightArrow1.classList.add("disabled");
    }
    targetContainer.innerHTML = html;
}

if (faqQuestions) {
    faqQuestions.forEach((q) => {
        q.addEventListener("click", function () {
            const item = this.parentElement;
            const isOpen = item.classList.contains("open");
            document
                .querySelectorAll(".faq-item.open")
                .forEach((i) => i.classList.remove("open"));
            if (!isOpen) item.classList.add("open");
        });
    });
}

const priceData = [
    {
        monthly: "<span>مجانية</span>",
        yearly: "<span>مجانية</span>",
    },
    {
        monthly: "<span class='price'>49 ريال</span> في الشهر",
        yearly: "<span class='price'>39 ريال</span> في الشهر",
    },
    {
        monthly: "<span class='price'>199 ريال</span> في الشهر",
        yearly: "<span class='price'>159 ريال</span> في الشهر",
    },
    {
        monthly: "<span class='price'>249 ريال</span> في الشهر",
        yearly: "<span class='price'>199 ريال</span> في الشهر",
    },
];

function updatePrices(isYearly) {
    document.querySelectorAll(".pricing-card .plan-price").forEach((el, i) => {
        el.innerHTML = isYearly ? priceData[i].yearly : priceData[i].monthly;
    });
}

if (btnMonthly) {
    btnMonthly.addEventListener("click", () => {
        btnMonthly.classList.add("active");
        btnYearly.classList.remove("active");
        updatePrices(false);
    });
}

if (btnYearly) {
    btnYearly.addEventListener("click", () => {
        btnYearly.classList.add("active");
        btnMonthly.classList.remove("active");
        updatePrices(true);
    });
}

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', () => {
	setYear();
	if (cardsContainer) setCards();
	
	// Determine which page we're on based on URL pathname
	const pathname = window.location.pathname;
	let eventWaysData = eventWays; // default
	
	if (pathname.includes('/recruiting')) {
		eventWaysData = eventWaysRecruiting;
	} else if (pathname.includes('/sales')) {
		eventWaysData = eventWaysSales;
	} else if (pathname.includes('/marketing')) {
		eventWaysData = eventWaysMarketing;
	} else if (pathname.includes('/customer-success')) {
		eventWaysData = eventWaysCustomerSuccess;
	} else if (pathname.includes('/services')) {
		eventWaysData = eventWaysServices;
	}
	
	if (cardsContainer1) setCardsOfEventWays(cardsContainer1, eventWaysData);
	if (cardsContainer2) setCardsOfEventTypes();
	// Set event types for page-specific wrappers
	if (cardsContainerSales) setCardsOfEventTypes(cardsContainerSales, eventTypesSales);
	if (cardsContainerRecruiting) setCardsOfEventTypes(cardsContainerRecruiting, eventTypesRecruiting);
	if (cardsContainerCustomerSuccess) setCardsOfEventTypes(cardsContainerCustomerSuccess, eventTypesCustomerSuccess);
	if (cardsContainerMarketing) setCardsOfEventTypes(cardsContainerMarketing, eventTypesMarketing);
	if (cardsContainerServices) setCardsOfEventTypes(cardsContainerServices, eventTypesServices);
	// Set features for all pages
	if (cardsContainerSalesFeatures) setCards(cardsContainerSalesFeatures, featuresSales);
	if (cardsContainerRecruitingFeatures) setCards(cardsContainerRecruitingFeatures, featuresRecruiting);
	if (cardsContainerCustomerSuccessFeatures) setCards(cardsContainerCustomerSuccessFeatures, featuresCustomerSuccess);
	if (cardsContainerMarketingFeatures) setCards(cardsContainerMarketingFeatures, featuresMarketing);
	if (cardsContainerServicesFeatures) setCards(cardsContainerServicesFeatures, featuresServices);

	// Initialize Swiper instances after content is added
	setTimeout(() => {
		// Initialize swiper1 if it doesn't exist
		if (!window.swiper1 && document.querySelector('.swiper1')) {
			window.swiper1 = new Swiper('.swiper1', {
				slidesPerView: 1,
				breakpoints: {
					320: {
						slidesPerView: 1.15,
					},
					480: {
						slidesPerView: 2,
					},
					992: {
						slidesPerView: 2,
						width: 900,
					},
					1200: {
						slidesPerView: 3,
					},
				},
				centeredSlides: false,
				spaceBetween: 15,
				navigation: {
					nextEl: '.swiper-button-next2',
					prevEl: '.swiper-button-prev2',
				},
			});
		} else if (window.swiper1) {
			window.swiper1.update();
		}

		// Initialize swiper2 if it doesn't exist
		if (!window.swiper2 && document.querySelector('.swiper2')) {
			window.swiper2 = new Swiper('.swiper2', {
				slidesPerView: 1,
				breakpoints: {
					320: {
						slidesPerView: 1.15,
					},
					480: {
						slidesPerView: 2,
					},
					992: {
						slidesPerView: 2,
						width: 900,
					},
					1200: {
						slidesPerView: 3,
					},
				},
				centeredSlides: false,
				spaceBetween: 15,
				navigation: {
					nextEl: '.swiper-button-next1',
					prevEl: '.swiper-button-prev1',
				},
			});
		} else if (window.swiper2) {
			window.swiper2.update();
		}
	}, 200);
});
menu.addEventListener("click", toggleMenu);

// Initialize prices on page load - set to yearly since yearly button is active by default
if (btnYearly && btnYearly.classList.contains("active")) {
    updatePrices(true);
}
// if (leftArrow) leftArrow.addEventListener('click', moveLeft);
// if (rightArrow) rightArrow.addEventListener('click', moveRight);
// window.addEventListener('resize', setMoveEnd);

// Hero section button click handlers
const googleLoginBtn = document.getElementById("google-login-btn");
const startFreeBtn = document.getElementById("start-free-btn");
const tryNowBtn = document.getElementById("try-now-btn");
const requestDemoBtn = document.getElementById("request-demo-btn");
//adding new comment

// Pricing page button click handlers
const pricingFreeBtn = document.getElementById("pricing-free-btn");
const pricingProBtn = document.getElementById("pricing-pro-btn");
const pricingTryNowBtn = document.getElementById("pricing-try-now-btn");

// Solution pages button click handlers
const priceBtns = document.querySelectorAll(".price-btn");
const showAllPlansBtn = document.querySelector(".show-all-plans");

// Helper function to preserve search parameters
function preserveSearchParams(baseUrl) {
    const currentSearch = window.location.search;
    if (currentSearch && currentSearch !== "?") {
        const separator = baseUrl.includes("?") ? "&" : "?";
        return `${baseUrl}${separator}${currentSearch.replace("?", "")}`;
    }
    return baseUrl;
}

// Google login button click handler
if (googleLoginBtn) {
    googleLoginBtn.addEventListener("click", function () {
        if (window.location.port === "") {
            // Production environment
            const hostParts = window.location.host.split(".");
            const baseUrl =
                hostParts.length > 2 && hostParts[0] !== "www"
                    ? `https://app-${hostParts[0]}.jadwalh.com`
                    : "https://app.jadwalh.com";

            // Check if user has token (you might need to implement token checking logic)
            const token =
                localStorage.getItem("token") ||
                sessionStorage.getItem("token");

            if (token) {
                window.location.href = preserveSearchParams(`${baseUrl}`);
            } else {
                window.location.href = preserveSearchParams(
                    `${baseUrl}/google-login-redirect`
                );
            }
        } else {
            // Development environment
            const token =
                localStorage.getItem("token") ||
                sessionStorage.getItem("token");

            if (token) {
                window.location.href = preserveSearchParams(
                    "http://localhost:3000"
                );
            } else {
                window.location.href = preserveSearchParams(
                    "http://localhost:3000/google-login-redirect"
                );
            }
        }
    });
}

// Start free button click handler
if (startFreeBtn) {
    startFreeBtn.addEventListener("click", function () {
        if (window.location.port === "") {
            // Production environment
            const hostParts = window.location.host.split(".");
            const baseUrl =
                hostParts.length > 2 && hostParts[0] !== "www"
                    ? `https://app-${hostParts[0]}.jadwalh.com`
                    : "https://app.jadwalh.com";

            window.location.href = preserveSearchParams(`${baseUrl}/register`);
        } else {
            // Development environment
            window.location.href = preserveSearchParams(
                "http://localhost:3000/register"
            );
        }
    });
}

// Try now button click handler (same functionality as start free)
if (tryNowBtn) {
    tryNowBtn.addEventListener("click", function () {
        if (window.location.port === "") {
            // Production environment
            const hostParts = window.location.host.split(".");
            const baseUrl =
                hostParts.length > 2 && hostParts[0] !== "www"
                    ? `https://app-${hostParts[0]}.jadwalh.com`
                    : "https://app.jadwalh.com";

            window.location.href = preserveSearchParams(`${baseUrl}/register`);
        } else {
            // Development environment
            window.location.href = preserveSearchParams(
                "http://localhost:3000/register"
            );
        }
    });
}

// Pricing page button click handlers
// Pricing free plan button
if (pricingFreeBtn) {
    pricingFreeBtn.addEventListener("click", function () {
        if (window.location.port === "") {
            // Production environment
            const hostParts = window.location.host.split(".");
            const baseUrl =
                hostParts.length > 2 && hostParts[0] !== "www"
                    ? `https://app-${hostParts[0]}.jadwalh.com`
                    : "https://app.jadwalh.com";

            window.location.href = preserveSearchParams(`${baseUrl}/register`);
        } else {
            // Development environment
            window.location.href = preserveSearchParams(
                "http://localhost:3000/register"
            );
        }
    });
}

// Pricing professional plan button
if (pricingProBtn) {
    pricingProBtn.addEventListener("click", function () {
        if (window.location.port === "") {
            // Production environment
            const hostParts = window.location.host.split(".");
            const baseUrl =
                hostParts.length > 2 && hostParts[0] !== "www"
                    ? `https://app-${hostParts[0]}.jadwalh.com`
                    : "https://app.jadwalh.com";

            window.location.href = preserveSearchParams(`${baseUrl}/register`);
        } else {
            // Development environment
            window.location.href = preserveSearchParams(
                "http://localhost:3000/register"
            );
        }
    });
}

// Pricing try now button
if (pricingTryNowBtn) {
    pricingTryNowBtn.addEventListener("click", function () {
        if (window.location.port === "") {
            // Production environment
            const hostParts = window.location.host.split(".");
            const baseUrl =
                hostParts.length > 2 && hostParts[0] !== "www"
                    ? `https://app-${hostParts[0]}.jadwalh.com`
                    : "https://app.jadwalh.com";

            window.location.href = preserveSearchParams(`${baseUrl}/register`);
        } else {
            // Development environment
            window.location.href = preserveSearchParams(
                "http://localhost:3000/register"
            );
        }
    });
}

// Request demo button click handler
if (requestDemoBtn) {
    requestDemoBtn.addEventListener("click", function () {
        window.location.href =
            "https://jadwalh.com/abdulrahman-saleh/1756388625953";
    });
}

// Price buttons (show all plans) click handlers
if (priceBtns) {
    priceBtns.forEach(function (btn) {
        btn.addEventListener("click", function () {
            // Navigate to pricing page with preserved search params
            const currentPath = window.location.pathname;
            const basePath = currentPath.includes("/solutions/")
                ? "../pricing"
                : "/pricing";
            const currentSearch = window.location.search;
            window.location.href = `${basePath}${currentSearch}`;
        });
    });
}

// Tabs functionality
document.addEventListener("DOMContentLoaded", function () {
    function initTabsContainer(containerId) {
        const container = document.getElementById(containerId);
        if (!container) return;

        const tabButtons = container.querySelectorAll(".tab-btn");
        const tabPanels = container.querySelectorAll(".tab-panel");

        function showTab(targetId) {
            // Hide all tab panels in this container
            tabPanels.forEach((panel) => {
                panel.classList.remove("active");
            });

            // Remove active class from all buttons in this container
            tabButtons.forEach((btn) => {
                btn.classList.remove("active");
            });

            // Show target panel
            const targetPanel = container.querySelector(`#${targetId}`);
            if (targetPanel) {
                targetPanel.classList.add("active");
            }

            // Add active class to clicked button
            const activeButton = container.querySelector(
                `[data-tab="${targetId}"]`
            );
            if (activeButton) {
                activeButton.classList.add("active");
            }
        }

        // Add click event listeners to tab buttons
        tabButtons.forEach((button) => {
            button.addEventListener("click", function () {
                const targetTab = this.getAttribute("data-tab");
                showTab(targetTab);
            });
        });

        // Initialize first tab as active if no tab is currently active
        const hasActiveTab = container.querySelector(".tab-btn.active");
        if (!hasActiveTab && tabButtons.length > 0) {
            const firstTab = tabButtons[0].getAttribute("data-tab");
            showTab(firstTab);
        }
    }

    // Initialize all tabs containers
    initTabsContainer("first-tabs-container");
    initTabsContainer("second-tabs-container");
    initTabsContainer("marketing-tabs-container");
    initTabsContainer("sales-tabs-container");
    initTabsContainer("recruiting-tabs-container");
    initTabsContainer("customer-success-tabs-container");
});
